import { useState, useEffect } from 'react'

// maxTimer is a duration in ms (e.g., 3000ms left)
const useTimer = ({ maxTimer }: { maxTimer: number }) => {
  const [timeLeft, setTimeLeft] = useState<number>(maxTimer)
  const [isExpired, setIsExpired] = useState<boolean>(false)

  useEffect(() => {
    setTimeLeft(maxTimer)
    setIsExpired(false)

    if (maxTimer <= 0) {
      setIsExpired(true)
      return
    }

    const interval = setInterval(() => {
      setTimeLeft((prevTime) => {
        const newTime = prevTime - 1000
        if (newTime <= 0) {
          setIsExpired(true)
          return 0
        }
        return newTime
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [maxTimer])

  return { timeLeft, isExpired }
}

export default useTimer
